import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, Instagram, Copy, Loader2, Sparkles } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { renderGlowCard, IG_TAG } from "../lib/glowcard";

const FILE = "gioia-glow-card.png";
const btn = "inline-flex justify-center items-center gap-2 rounded-full px-6 py-3.5 text-[0.7rem] tracking-[0.2em] uppercase transition-colors duration-300";

const copyTag = async () => {
  try { await navigator.clipboard.writeText(IG_TAG); toast.success(`${IG_TAG} copiato`); } catch { toast.error("Copia non riuscita"); }
};

const download = (blob) => {
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = FILE;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
};

export const GlowCard = ({ result }) => {
  const [open, setOpen] = useState(false);
  const [blob, setBlob] = useState(null);
  const [preview, setPreview] = useState("");

  useEffect(() => {
    if (!open || blob) return undefined;
    let alive = true;
    renderGlowCard({ ...result, url: `${window.location.host}/quiz-pelle` })
      .then((b) => { if (alive && b) { setBlob(b); setPreview(URL.createObjectURL(b)); } })
      .catch(() => { if (alive) toast.error("Non è stato possibile creare la card"); });
    return () => { alive = false; };
  }, [open, blob, result]);

  const share = async () => {
    const file = new File([blob], FILE, { type: "image/png" });
    if (navigator.canShare?.({ files: [file] })) {
      try {
        await navigator.clipboard?.writeText(IG_TAG).catch(() => {});
        await navigator.share({ files: [file], text: `Il mio trattamento ideale da ${IG_TAG}` });
      } catch { /* annullato dall'utente */ }
      return;
    }
    download(blob);
    toast.success("Card scaricata: caricala nelle tue Stories e tagga " + IG_TAG);
  };

  return (
    <>
      <button type="button" data-testid="glow-card-open-btn" onClick={() => setOpen(true)}
        className={`${btn} border border-[#C9A66B] text-[#C9A66B] px-7 py-4 text-[0.72rem] hover:bg-[#C9A66B] hover:text-[#14110F]`}>
        <Sparkles className="w-4 h-4" /> Crea la tua Glow Card
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="glow-card-dialog" className="bg-[#14110F] border-[#F6F2EC]/15 text-[#F6F2EC] max-w-[92vw] sm:max-w-md max-h-[92vh] overflow-y-auto">
          <DialogTitle className="font-serif-d font-light text-3xl">La tua Glow Card</DialogTitle>
          <DialogDescription className="text-sm text-[#c9bfb2]">
            Pubblicala nelle tue Stories di Instagram e tagga <span className="text-[#C9A66B]">{IG_TAG}</span>: la ricondivideremo.
          </DialogDescription>
          <div className="mx-auto w-full max-w-[260px] aspect-[9/16] bg-[#1d1916] flex items-center justify-center overflow-hidden" data-testid="glow-card-preview">
            {preview ? <img src={preview} alt="Glow Card con il tuo trattamento ideale" className="w-full h-full object-cover" /> : <Loader2 className="w-6 h-6 animate-spin text-[#C9A66B]" />}
          </div>
          <div className="grid gap-3">
            <button type="button" data-testid="glow-card-share-btn" disabled={!blob} onClick={share} className={`${btn} bg-[#C9A66B] text-[#14110F] font-medium hover:bg-[#F6F2EC] disabled:opacity-50`}>
              <Instagram className="w-4 h-4" /> Condividi nelle Stories
            </button>
            <div className="grid grid-cols-2 gap-3">
              <button type="button" data-testid="glow-card-download-btn" disabled={!blob} onClick={() => download(blob)} className={`${btn} px-3 border border-[#F6F2EC]/30 hover:border-[#C9A66B] hover:text-[#C9A66B] disabled:opacity-50`}>
                <Download className="w-4 h-4" /> Scarica
              </button>
              <button type="button" data-testid="glow-card-copy-tag-btn" onClick={copyTag} className={`${btn} px-3 border border-[#F6F2EC]/30 hover:border-[#C9A66B] hover:text-[#C9A66B]`}>
                <Copy className="w-4 h-4" /> Copia tag
              </button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
